import { render, staticRenderFns } from "./CurrentAddress.vue?vue&type=template&id=63fd4c09&"
import script from "./CurrentAddress.vue?vue&type=script&lang=js&"
export * from "./CurrentAddress.vue?vue&type=script&lang=js&"
import style0 from "./CurrentAddress.vue?vue&type=style&index=0&id=63fd4c09&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports